<div>
  <mat-toolbar>
    <h2>Approve Quote for Production</h2>
  </mat-toolbar>
  <mat-dialog-content>
    <form [formGroup]="approveForm">
      <div class="mt-4 grid grid-cols-2 gap-6">
        <mat-form-field class="w-full">
          <mat-label>Purchase Order Number</mat-label>
          <input matInput formControlName="clientPurchaseOrder" placeholder="Enter PO number" />
        </mat-form-field>

        <mat-form-field class="w-full">
          <mat-label>Confirmed Quantity</mat-label>
          <mat-select formControlName="totalQuantity">
            @for (option of quantityOptions; let i = $index; track i) {
              <mat-option [value]="option">{{ option.quantityBreak }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <div class="grid grid-cols-2 gap-4 w-full">
          <div class="flex items-center">
            @if (isUploading()) {
              <mat-progress-spinner
                diameter="24"
                mode="indeterminate"
                class="mr-2"
              ></mat-progress-spinner>
              <span class="text-sm">Uploading...</span>
            } @else if (purchaseOrderDocument?.value) {
              <label class="text-sm text-gray-700">
                {{ purchaseOrderDocument?.value }}
              </label>
            } @else {
              <label class="text-sm text-gray-700">No file selected</label>
            }
            @if (uploadError()) {
              <span class="text-sm text-red-500 ml-2">
                {{ uploadError() }}
              </span>
            }
          </div>

          <div class="flex items-center gap-2">
            <input
              type="file"
              accept=".pdf"
              (change)="onFileSelected($event)"
              #fileInput
              style="display: none"
            />
            <button
              mat-flat-button
              color="accent"
              type="button"
              (click)="fileInput.click()"
              [disabled]="isUploading()"
            >
              {{ purchaseOrderDocument?.value ? 'Change File' : 'Upload PDF' }}
            </button>
          </div>
        </div>

        <mat-form-field class="w-full">
          <mat-label>Amount of Weeks</mat-label>
          <mat-select formControlName="weeksAmount">
            @for (option of weeksOptions; track option.value) {
              <mat-option [value]="option.value">{{ option.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-flat-button type="button" (click)="onCancel()" [disabled]="isCreatingOrder()">
      Cancel
    </button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="!approveForm.valid || isCreatingOrder()"
      (click)="onSubmit()"
    >
      Approve
    </button>
  </mat-dialog-actions>
</div>
